import { ICellRendererParams } from 'ag-grid-community';
import { Button, Icon } from '@opengov/component-library/dist';
import React from 'react';
import styles from './DimensionalSummaryTableRenderer.module.scss';

export interface IDimensionalSummaryTableRendererProps extends ICellRendererParams {
  onClick?(rowIndex: number | null, nodeId: string): void;
}

const SettingsIconButton = ({ onClick }: { onClick: () => void }) => (
  <Button dataTest="utility-settings" variant="neutral" size="small" onClick={onClick}>
    <Icon icon="utility-settings" />
  </Button>
);

export const DimensionalSummaryTableRenderer = (props: IDimensionalSummaryTableRendererProps) => {
  const value = props.value as string;
  const containerClass = (styles as Record<string, string>).summaryTableRenderer;
  return (
    <div data-test={value} className={containerClass}>
      {value}
      {props.node.level === 0 && props.onClick && (
        <SettingsIconButton onClick={() => props.onClick?.(props.node.rowIndex, props.node.id ?? '')} />
      )}
    </div>
  );
};
